import { createReducer, on } from '@ngrx/store';
import { setStateAction } from '../actions/admin-esm-revenue-head.actions';
import { Action } from '../../models';
import dayjs from 'dayjs';

export interface EsmRevenueHeadReducerInitialState {
  maxDate: string;
  minDate: string;
  esId: string;
}

export const initialState: EsmRevenueHeadReducerInitialState = {
  maxDate: '',
  minDate: '',
  esId: '',
};

const reducer = createReducer(
  initialState,
  on(setStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  })
);

export function esmRevenueHeadReducerReducer(
  state: EsmRevenueHeadReducerInitialState,
  action: Action
) {
  return reducer(state, action);
}
